module.exports = __webpack_public_path__ + "static/img/outer-corner-quarter-pipe_256.b2c2aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer-corner-quarter-pipe_256.png
// module id = LLV7
// module chunks = 0